/* ICARUS — Theme JavaScript */
(function () {
  'use strict';

  // ─── Mobile Nav ─────────────────────────────────────────────────────────
  const hamburger    = document.querySelector('.hamburger');
  const mobileNav    = document.getElementById('mobile-nav');
  const mobileClose  = document.querySelector('[data-mobile-nav-close]');
  const mobileOverlay = document.querySelector('[data-mobile-nav-overlay]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'false');
    mobileNav.classList.add('mobile-nav--open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileNav.classList.remove('mobile-nav--open');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', openMobileNav);
  mobileClose?.addEventListener('click', closeMobileNav);
  mobileOverlay?.addEventListener('click', closeMobileNav);

  // ─── Cart Drawer ─────────────────────────────────────────────────────────
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');
  const cartClose   = cartDrawer?.querySelector('.cart-drawer__close');
  const cartTrigger = document.querySelectorAll('[data-cart-trigger]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartTrigger.forEach(btn => btn.addEventListener('click', openCart));
  cartOverlay?.addEventListener('click', closeCart);
  cartClose?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeMobileNav(); } });

  // ─── Cart API ────────────────────────────────────────────────────────────
  function fetchCart() {
    return fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [], total_price: 0 }));
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function refreshCart() {
    const cart = await fetchCart();
    const itemsEl = document.getElementById('cart-items');
    const priceEl = document.getElementById('cart-subtotal-price');
    const countEl = document.querySelectorAll('[data-cart-count]');

    const totalItems = cart.items.reduce((sum, i) => sum + i.quantity, 0);
    countEl.forEach(el => {
      el.textContent = totalItems;
      el.dataset.count = totalItems;
    });

    if (priceEl) priceEl.textContent = formatMoney(cart.total_price);

    if (!itemsEl) return;
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}
        </div>
        <div>
          <p class="cart-item__name">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:.75rem;color:var(--ic-muted);margin-bottom:.25rem;">${item.variant_title}</p>` : ''}
          <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
          <div class="cart-item__qty">
            <button class="cart-qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease">−</button>
            <span class="cart-item__qty-num">${item.quantity}</span>
            <button class="cart-qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase">+</button>
          </div>
        </div>
        <button class="cart-item__remove" data-action="remove" data-key="${item.key}" data-qty="0">✕</button>
      </div>
    `).join('');

    itemsEl.querySelectorAll('.cart-qty-btn, .cart-item__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const currentQty = parseInt(btn.dataset.qty);
        const newQty = btn.dataset.action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        refreshCart();
      });
    });
  }

  // ─── Add to Cart ─────────────────────────────────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const data = new FormData(form);
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: data
        });
        if (response.ok) {
          btn.textContent = 'Added!';
          setTimeout(() => { openCart(); btn.textContent = originalText; btn.disabled = false; }, 600);
        } else {
          btn.textContent = 'Error — try again';
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
        }
      } catch {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  // ─── Quote / Contact Form ─────────────────────────────────────────────────
  document.querySelectorAll('.js-quote-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const successMsg = form.querySelector('.form-success');
      const originalText = btn.textContent;
      btn.textContent = 'Sending…';
      btn.disabled = true;

      const body = Object.fromEntries(new FormData(form).entries());

      try {
        const res = await fetch(form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (res.ok) {
          form.reset();
          if (successMsg) { successMsg.style.display = 'block'; }
          btn.textContent = 'Sent!';
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; if (successMsg) successMsg.style.display = 'none'; }, 4000);
        } else {
          btn.textContent = 'Error — try again';
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
        }
      } catch {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  // ─── Newsletter ───────────────────────────────────────────────────────────
  document.querySelectorAll('.js-newsletter').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const success = form.nextElementSibling;
      btn.textContent = '…';
      btn.disabled = true;

      try {
        await fetch('/contact#newsletter', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        });
        form.style.display = 'none';
        if (success?.classList.contains('newsletter-success')) success.style.display = 'block';
      } catch {
        btn.textContent = 'Subscribe';
        btn.disabled = false;
      }
    });
  });

  // ─── Product media gallery + variant picker ───────────────────────────────
  const mainMediaImg = document.querySelector('.product-media__main img');
  const mediaThumbs = document.querySelectorAll('.product-media__thumb');

  function showThumb(thumb) {
    if (!mainMediaImg || !thumb || !thumb.dataset.mainSrc) return;
    mediaThumbs.forEach(t => t.classList.remove('product-media__thumb--active'));
    thumb.classList.add('product-media__thumb--active');
    mainMediaImg.removeAttribute('srcset');
    mainMediaImg.src = thumb.dataset.mainSrc;
    const thumbImg = thumb.querySelector('img');
    if (thumbImg) mainMediaImg.alt = thumbImg.alt;
  }

  const variantJsonEl = document.querySelector('[data-variant-json]');
  const productVariants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : null;

  function variantImageId(v) {
    return v && v.featured_image ? String(v.featured_image.id) : null;
  }

  // Show the image tied to the chosen variant (e.g. picking "black" shows the black tee)
  function syncGalleryToVariant(variant) {
    const imgId = variantImageId(variant);
    if (!imgId || !mediaThumbs.length) return;
    const match = Array.from(mediaThumbs).find(t => t.dataset.imageId === imgId);
    if (match) {
      showThumb(match);
    } else if (mainMediaImg && variant.featured_image.src) {
      mainMediaImg.removeAttribute('srcset');
      mainMediaImg.src = variant.featured_image.src;
    }
  }

  // Reverse: an image that belongs to exactly one option value selects that value
  function optionValuesForImage(imageId) {
    if (!productVariants) return null;
    const owners = productVariants.filter(v => variantImageId(v) === imageId);
    if (!owners.length) return null;
    const out = {};
    [1, 2, 3].forEach(pos => {
      const key = 'option' + pos;
      const value = owners[0][key];
      if (value == null) return;
      const sameValue = owners.every(v => v[key] === value);
      const allWithValue = productVariants.filter(v => v[key] === value).length;
      if (sameValue && allWithValue === owners.length) out[pos] = value;
    });
    return out;
  }

  function selectedOptionValues() {
    const values = [];
    document.querySelectorAll('.product-variants').forEach(group => {
      const active = group.querySelector('.swatch--active');
      if (active) values[parseInt(active.dataset.optionPosition, 10) - 1] = active.dataset.value;
    });
    return values;
  }

  function matchVariant(values) {
    if (!productVariants) return null;
    return productVariants.find(v => values.every((val, i) => v['option' + (i + 1)] === val)) || null;
  }

  function updateVariantUI() {
    if (!productVariants) return;
    const values = selectedOptionValues();
    const variant = matchVariant(values);

    document.querySelectorAll('.product-variants').forEach(group => {
      const active = group.querySelector('.swatch--active');
      const label = group.querySelector('.product-variants__label strong');
      if (active && label) label.textContent = active.dataset.value;

      group.querySelectorAll('.swatch').forEach(s => {
        const test = values.slice();
        test[parseInt(s.dataset.optionPosition, 10) - 1] = s.dataset.value;
        const candidate = matchVariant(test);
        s.classList.toggle('swatch--soldout', !candidate || !candidate.available);
      });
    });

    const form = document.querySelector('form[data-add-to-cart]');
    const idInput = form?.querySelector('input[name="id"]');
    const submitBtn = form?.querySelector('[type="submit"]');
    const priceEl = document.querySelector('.product-info__price');

    if (variant) {
      syncGalleryToVariant(variant);
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
    if (submitBtn) {
      const canAdd = !!variant && variant.available;
      submitBtn.disabled = !canAdd;
      submitBtn.textContent = canAdd
        ? (submitBtn.dataset.labelAdd || 'Add to Cart')
        : (submitBtn.dataset.labelSoldout || 'Sold Out');
    }
  }

  function selectSwatch(position, value) {
    const btn = document.querySelector(
      '.swatch[data-option-position="' + position + '"][data-value="' + CSS.escape(value) + '"]'
    );
    if (!btn || btn.classList.contains('swatch--active')) return false;
    btn.closest('.variant-options')?.querySelectorAll('.swatch').forEach(s => s.classList.remove('swatch--active'));
    btn.classList.add('swatch--active');
    return true;
  }

  document.querySelectorAll('.swatch').forEach(sw => {
    sw.addEventListener('click', () => {
      sw.closest('.variant-options')?.querySelectorAll('.swatch').forEach(s => s.classList.remove('swatch--active'));
      sw.classList.add('swatch--active');
      updateVariantUI();
    });
  });

  mediaThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      showThumb(thumb);
      const owned = thumb.dataset.imageId ? optionValuesForImage(thumb.dataset.imageId) : null;
      if (!owned) return;
      let changed = false;
      Object.keys(owned).forEach(pos => {
        if (selectSwatch(pos, owned[pos])) changed = true;
      });
      if (changed) updateVariantUI();
    });
  });

  if (productVariants) updateVariantUI();

  // ─── Collection filter buttons ────────────────────────────────────────────
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('filter-btn--active'));
      btn.classList.add('filter-btn--active');
      const tag = btn.dataset.tag;
      document.querySelectorAll('.product-card').forEach(card => {
        if (!tag || tag === 'all') {
          card.closest('[data-product-item]').style.display = '';
        } else {
          const cardTags = card.closest('[data-product-item]').dataset.tags || '';
          card.closest('[data-product-item]').style.display = cardTags.includes(tag) ? '' : 'none';
        }
      });
    });
  });

  // ─── Init ─────────────────────────────────────────────────────────────────
  refreshCart();

})();
